import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { 
  IDocumentoResponse, 
  IDocumentoRequest, 
  IDocumentoSaveRequest, 
  IDocumentoSaveResponse 
} from '../interfaces/documento.interface';

@Injectable({
  providedIn: 'root'
})
export class DocumentoService {
  private readonly API_URL = `${environment.apiNewBackBaseUrl}RutaCritica/GetCatalogodoc`;
  private readonly API_URL_SAVE = `${environment.apiNewBackBaseUrl}MntoSolicitudes/GetCatagErr`;
  private readonly API_URL_EDIT = `${environment.apiNewBackBaseUrl}MntoSolicitudes/GetCatag5`;

  constructor(private http: HttpClient) { }

  getDocumentos(request: IDocumentoRequest): Observable<IDocumentoResponse> {
    return this.http.post<IDocumentoResponse>(this.API_URL, request);
  }

  getDocumentoByClave(clave: string): Observable<IDocumentoResponse> {
    const payload: IDocumentoRequest = {
      tope: "999",
      clavedocumento: clave,
      descripcion: '',
      aplicavigencia: 0,
      score: 0
    };
    return this.http.post<IDocumentoResponse>(this.API_URL, payload);
  }

  getDocumentoForEdit(clave: string): Observable<IDocumentoResponse> {
    const payload: IDocumentoRequest = {
      tope: "100",
      clavedocumento: clave,
      descripcion: '',
      aplicavigencia: 0,
      score: 0
    };
    return this.http.post<IDocumentoResponse>(this.API_URL_EDIT, payload);
  }

  saveDocumento(payload: IDocumentoSaveRequest): Observable<IDocumentoSaveResponse> {
    return this.http.post<IDocumentoSaveResponse>(this.API_URL_SAVE, payload);
  }

  deleteDocumento(clave: string): Observable<IDocumentoSaveResponse> {
    const payload: IDocumentoSaveRequest = {
      que: 3,
      tope: '',
      clavedocumento: clave,
      descripcion: '',
      aplicavigencia: 0,
      score: 0
    };
    return this.http.post<IDocumentoSaveResponse>(this.API_URL_SAVE, payload);
  }
} 